<template>
	<ChartAxisConfig v-if="leftAxisSync" v-model="leftAxisSync" :name="$t('dashboard.leftAxis')" />
	<ChartAxisConfig
		v-if="bottomAxisSync"
		v-model="bottomAxisSync"
		:name="$t('dashboard.bottomAxis')"
	/>
	<PeriodSelection
		class="mx-4 mt-2"
		:label="$t('common.period')"
		v-bind="periodField.attrs as any"
		required
		@update:modelValue="saveChanges"
	/>
	<SoftSwitch v-model="alignPeriod" class="m-4" :label="$t('dashboard.alignPeriod')" />
	<SoftSwitch
		v-model="openDialogOnClickSync"
		class="m-4"
		:label="$t('dashboard.openCommentDialog')"
	/>
</template>

<script lang="ts">
import PeriodSelection from "@/components/helpers/PeriodSelection";
import { useForm } from "@soft-db/form";
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { PropType, defineComponent } from "vue";
import ChartAxisConfig from "../../config/ChartAxisConfig.vue";
import { CommentBarOptions, defaultCommentBarOptions } from "./comment-bar-options";

export default defineComponent({
	components: { ChartAxisConfig, PeriodSelection },
	name: "CommentBarPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<CommentBarOptions>,
			default: () => defaultCommentBarOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const axesSync = useRefObjectSync(valueModel, "axes");
		const leftAxisSync = useRefObjectSync(axesSync, "left");
		const bottomAxisSync = useRefObjectSync(axesSync, "bottom");

		const period = useRefObjectSync(valueModel, "period");
		const alignPeriod = useRefObjectSync(valueModel, "alignPeriod");

		const { useField, handleSubmit } = useForm<CommentBarOptions>({ mode: "immediate" });
		const periodField = useField("period", {
			isNumber: true,
			isRequired: true,
			min: 1,
			initialValue: period.value || 5,
		});

		const saveChanges = handleSubmit((options) => (period.value = options.period));

		const openDialogOnClickSync = useRefObjectSync(valueModel, "openDialogOnClick");

		return {
			leftAxisSync,
			bottomAxisSync,
			periodField,
			alignPeriod,
			saveChanges,
			openDialogOnClickSync,
		};
	},
});
</script>
